import {
  Component,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import confetti from 'canvas-confetti';
import { LayoutService } from '../../core/services/layout/layout.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../core/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CreateOrderService } from '../../core/services/create-order/create-order.service';
import { MatDialog } from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RechargeService } from '../../services/recharge/recharge.service';
import { KycServiceService } from '../../core/services/kyc-service/kyc-service.service';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-topbar',

  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone: true,
  imports: [
    NgxSpinnerModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    NgbTooltipModule,
  ],
})
export class TopbarComponent implements OnInit, OnDestroy {
  private outsideClickUnlisten: (() => void) | null = null;
  @ViewChild('paymentSuccessModal') paymentSuccessModal!: TemplateRef<any>;
  @ViewChild('paymentFailureModal') paymentFailureModal!: TemplateRef<any>;
  paymentResult: any;
  paymentError: string = '';
  walletBalanceAmt: any;
  user: any;
  rechargeForm!: FormGroup;

  minRechargeAmount = 500;

  quickAmounts = [10000, 50000, 100000, 200000, 500000];

  selectedAmount!: number;
  kycProfile: any;
  activePlanName: any;
  activePlanId: any;
  kycStatus: any;
  isWalletRefreshHidden = false;

  private walletRefreshTimer: any;
  constructor(
    private renderer: Renderer2,
    private layout: LayoutService,
    private authService: AuthService,
    private loader: NgxSpinnerService,
    private toaster: ToastrService,
    private router: Router,
    private createOrder: CreateOrderService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private zone: NgZone,
    private rechargeService: RechargeService,
    private kycProfileService: KycServiceService,
  ) { }
  ngOnInit() {
    this.walletBalance(false);
    this.user = this.authService.getUser();
    this.rechargeForm = this.fb.group({
      amount: [
        null,
        [Validators.required, Validators.min(this.minRechargeAmount)],
      ],

      acceptCharges: [false, Validators.requiredTrue],
    });
    //  console.log("userData",this.user)
    this.kycProfileService.profile$.subscribe({
      next: (data: any) => {
        this.kycProfile = data;

        this.activePlanName =
          data?.master_user_plan?.master_plan_type?.planName || '';

        this.activePlanId =
          data?.master_user_plan?.master_plan_type?.planId || null;

        this.kycStatus = data?.kyc_profile?.kyc_status?.statusName || '';


      },
    });
    this.kycProfileService.loadProfileAfterLogin();
  }
  walletBalance(hideRefreshIcon: boolean = true): void {
    this.loader.show();

    this.authService.getWalletBalance().subscribe({
      next: (res: any) => {
        this.loader.hide();

        if (res?.status) {
          this.walletBalanceAmt = Number(res?.data?.balance || 0);
          if (hideRefreshIcon) {
            this.kycProfileService.refreshProfile();
            this.isWalletRefreshHidden = true;
            if (this.walletRefreshTimer) {
              clearTimeout(this.walletRefreshTimer);
            }
            this.walletRefreshTimer = setTimeout(
              () => {
                this.isWalletRefreshHidden = false;
              },
              10 * 60 * 1000,
            );
          }
        }
      },

      error: (err: any) => {
        this.loader.hide();
        this.toaster.error(err?.error?.message);
      },
    });
  }
  toggleSidebar() {
    const html = document.documentElement;
    if (html.classList.contains('sidebar-enable')) {
      this.layout.open();
    } else {
      this.openSidebar();
    }
  }

  openSidebar() {
    const html = document.documentElement;
    const body = document.body;

    html.classList.add('sidebar-enable');
    body.style.overflow = 'hidden';

    // outside click listener
    this.outsideClickUnlisten = this.renderer.listen(
      'document',
      'click',
      (event: Event) => {
        const target = event.target as HTMLElement;

        if (
          !target.closest('.sidenav-menu') &&
          !target.closest('.sidenav-toggle-button')
        ) {
          this.closeSidebar();
        }
      },
    );
  }

  closeSidebar() {
    const html = document.documentElement;
    const body = document.body;

    html.classList.remove('sidebar-enable');
    body.style.overflow = '';

    if (this.outsideClickUnlisten) {
      this.outsideClickUnlisten();
      this.outsideClickUnlisten = null;
    }
  }

  onLogout() {
    // console.log("Logout clicked");
    this.loader.show();
    this.authService.logout().subscribe({
      next: (res: any) => {
        this.loader.hide();

        if (res.status) {
          this.kycProfileService.clearProfile();
          this.createOrder.clearKycCache();
          this.router.navigate(['/login']);
          this.toaster.success(res?.message);
        }
      },
      error: (err) => {
        this.loader.hide();
        this.toaster.success(err?.error?.error);

        console.error('Logout error', err);
      },
    });
  }
  // walletBalance() {
  //   this.loader.show();
  //   this.authService.getWalletBalance().subscribe({
  //     next: (res: any) => {
  //       this.loader.hide();

  //       if (res.status) {
  //         const balance = res?.data?.balance;
  //         this.walletBalanceAmt = this.formatAmount(balance);
  //       }
  //     },
  //     error: (err) => {
  //       this.loader.hide();
  //       this.toaster.success(err?.error?.message);

  //     },
  //   });
  // }
  // isWalletRefreshHidden: boolean = false;
  // private walletRefreshTimer: any;

  // walletBalance() {
  //   this.loader.show();

  //   this.authService.getWalletBalance().subscribe({
  //     next: (res: any) => {
  //       this.loader.hide();

  //       if (res.status) {
  //         const balance = Number(res?.data?.balance || 0);

  //         this.walletBalanceAmt = balance;

  //         this.isWalletRefreshHidden = true;

  //         if (this.walletRefreshTimer) {
  //           clearTimeout(this.walletRefreshTimer);
  //         }

  //         this.walletRefreshTimer = setTimeout(() => {
  //           this.isWalletRefreshHidden = false;
  //         }, 10 * 60 * 1000);
  //       }
  //     },
  //     error: (err) => {
  //       this.loader.hide();
  //       this.toaster.error(err?.error?.message);
  //     }
  //   });
  // }
  // private hideWalletRefreshFor10Minutes(): void {
  //   this.isWalletRefreshHidden = true;
  //   if (this.walletRefreshTimer) {
  //     clearTimeout(this.walletRefreshTimer);
  //   }

  //   this.walletRefreshTimer = setTimeout(() => {
  //     this.isWalletRefreshHidden = false;
  //   }, 10 * 60 * 1000);
  // }
  openProfile() {
    // this.router.navigate(['/kyc/kyc/kyc_profile']);
    this.router.navigate(['/kyc/kyc_profile']);
  }

  formatAmount(amount: number): string {
    if (!amount) return '0';

    if (amount >= 10000000) {
      return (amount / 10000000).toFixed(2).replace(/\.00$/, '') + 'Cr';
    }

    if (amount >= 100000) {
      return (amount / 100000).toFixed(2).replace(/\.00$/, '') + 'L';
    }

    if (amount >= 1000) {
      return (amount / 1000).toFixed(2).replace(/\.00$/, '') + 'K';
    }

    return amount.toString();
  }

  openRechargeModel(model: any) {
    this.dialog.open(model, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      disableClose: true,
      panelClass: 'responsive-dialog'
    });
  }
  bankDetailsList = [
    { label: 'Account No.', value: '50200117475309', copy: true },
    { label: 'Bank Name', value: 'HDFC Bank', copy: false },
    { label: 'IFSC', value: 'HDFC0011112', copy: true },
    {
      label: 'Account Name',
      value: 'FASTGLOBE TECHNOLOGIES PRIVATE LIMITED',
      copy: false,
    },
  ];

  copyText(value: string) {
    navigator.clipboard.writeText(value);
    // this.toastr.success('Copied Successfully');
  }
  selectAmount(amount: number) {
    this.selectedAmount = amount;

    this.rechargeForm.patchValue({
      amount: amount,
    });
  }
  resetForm() {
    this.selectedAmount = 0;

    this.rechargeForm.reset({
      amount: null,
      acceptCharges: false,
    });
  }

  shortAMT(amount: number): string {
    if (amount >= 10000000) {
      return `${amount / 10000000} Cr`;
    }

    if (amount >= 100000) {
      return `${amount / 100000} Lac`;
    }

    if (amount >= 1000) {
      return `${amount / 1000}K`;
    }

    return amount.toString();
  }
  closeModal() {
    this.dialog.closeAll();
    this.resetForm();
  }

  loadRazorpayScript(): Promise<boolean> {
    return new Promise((resolve) => {
      if ((window as any).Razorpay) {
        resolve(true);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  }

  payWithRazor(data: any): void {
    const { razorpay_order_id, amount, currency, key } = data;
    const options: any = {
      key,
      amount: amount * 100,
      currency,
      name: 'Fastglobe',
      description: 'Wallet Recharge',
      order_id: razorpay_order_id,
      modal: { escape: false },
      notes: {},
      theme: { color: '#0c238a' },
      prefill: {
        name: this.user?.customer?.firstname || '',
        email: this.user?.customer?.email || '',
        contact: this.user?.customer?.mobile || '',
      },
    };
    options.handler = (response: any) => {
      this.zone.run(() => {
        const verifyPayload = {
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        };
        this.loader.show();
        this.rechargeService.verifyRazorpayPayment(verifyPayload).subscribe({
          next: (res: any) => {
            this.loader.hide();
            if (res?.status) {
              this.paymentResult = res.data;
              this.walletBalance();
              this.dialog.open(this.paymentSuccessModal, {
                disableClose: true,
                panelClass: 'dialog-sm',
              });
              confetti({ particleCount: 150, spread: 70, origin: { y: 0.6 } });
            } else {
              this.paymentError =
                res?.message ||
                'Payment verification failed. Please contact support.';
              this.dialog.open(this.paymentFailureModal, {
                disableClose: true,
                panelClass: 'dialog-sm',
              });
            }
          },
          error: (err: any) => {
            this.loader.hide();
            this.paymentError =
              err?.error?.message ||
              'Payment verification failed. Please contact support.';
            this.dialog.open(this.paymentFailureModal, {
              disableClose: true,
              panelClass: 'dialog-sm',
            });
          },
        });
      });
    };
    options.modal.ondismiss = () => {
      this.zone.run(() => this.toaster.info('Payment cancelled'));
    };
    const rzp = new (window as any).Razorpay(options);
    rzp.open();
  }

  proceedToPay() {
    if (this.rechargeForm.invalid) {
      this.rechargeForm.markAllAsTouched();
      return;
    }

    const payload = {
      amount: Number(this.rechargeForm.value.amount),
    };

    this.loader.show();

    this.rechargeService.createRazorpayOrder(payload).subscribe({
      next: (res: any) => {
        this.loader.hide();

        if (res?.status) {
          this.dialog.closeAll();
          this.loadRazorpayScript().then(() => this.payWithRazor(res.data));
        } else {
          this.toaster.error(res?.message || 'Something went wrong');
        }
      },

      error: (error: any) => {
        this.loader.hide();

        this.toaster.error(
          error?.error?.message || 'Unable to create payment order.',
        );
      },
    });
  }
  ngOnDestroy() {
    if (this.outsideClickUnlisten) {
      this.outsideClickUnlisten();
    }
  }
}
